import type { ApiGroup, Group } from '../types';

export const toGroup = (api: ApiGroup): Group => ({
  id: api.id,
  name: api.name,
  location: { id: api.location.id, name: api.location.name },
});
